import type {Thread} from '@github-ui/diff-lines/conversation-types'
import {ProfileReference} from '@github-ui/profile-reference'
import {Link} from '@github-ui/react-router'
import {useGetHovercardAttributesForType} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'
import {ThreadGroupVariant, getThreadAuthor, ThreadGroupVariantLabels} from '../util/classify-thread'
import {getThreadFileLabel} from '../util/thread-file-label'
import styles from './ThreadTitle.module.css'

function ThreadMessage({variant}: {variant: ThreadGroupVariant}) {
  return <span>&nbsp;{ThreadGroupVariantLabels[variant] || 'commented'}</span>
}

export function ThreadTitle({thread, variant}: {thread?: Thread | null; variant: ThreadGroupVariant}) {
  const getHovercardAttributesForType = useGetHovercardAttributesForType()

  const message = <ThreadMessage variant={variant} />

  // Falls back to the ghost user (login `ghost`, profile `/ghost`) when the
  // comment author no longer exists, matching the expanded thread view.
  const author = getThreadAuthor(thread, variant)

  // When the thread is code-anchored, show the file name (and lines) inline in the
  // header. The full file path is shown only once the item is expanded.
  const fileLabel = thread ? getThreadFileLabel(thread) : null

  return (
    <span className={styles.ThreadTitle}>
      {author.linkable ? (
        <Link
          to={`/${author.login}`}
          className="color-fg-default text-bold"
          {...getHovercardAttributesForType('user', {login: author.login})}
        >
          <ProfileReference login={author.login} isAgent={false} />
        </Link>
      ) : (
        <span>
          <ProfileReference login={author.login} isAgent={false} />
        </span>
      )}
      {message}
      {fileLabel?.hasFile ? (
        <>
          <span>&nbsp;on&nbsp;</span>
          <span className={styles.fileName}>{fileLabel.fileName}</span>
          {fileLabel.hasLine ? <span className={styles.lines}>&nbsp;{fileLabel.lineText}</span> : null}
        </>
      ) : null}
    </span>
  )
}
